module.exports = __webpack_public_path__ + "static/media/ArrowDownWarning.72d11310.svg";